import { render, staticRenderFns } from "./StandingsDetailsPage.vue?vue&type=template&id=f5d03e1c&scoped=true"
import script from "./StandingsDetailsPage.vue?vue&type=script&lang=ts"
export * from "./StandingsDetailsPage.vue?vue&type=script&lang=ts"
import style0 from "./StandingsDetailsPage.vue?vue&type=style&index=0&id=f5d03e1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d03e1c",
  null
  
)

export default component.exports